module.exports = __webpack_public_path__ + "img/skew_backgroung_dark_blue.ffea98fb.png";